import { useUserInfo } from "../context/user";

function useAuth(): string | null {
  const { user } = useUserInfo();
  // Check if 'user' is defined before attempting to destructure
  return user && user.token ? user.token : null;
}

function useLogout(): () => void {
  const { clear } = useUserInfo();
  // const navigate = useNavigate();

  return () => {
    localStorage.clear();
    window.location.href="/login"
    // navigate('/auth/sign-in');
  };
}

export { useAuth, useLogout };
